  export const servicesEditFields = [
      {
        name: "ServiceEndPointCode",
        isPass: false,
        isEmail: false,
        type: "text",
        group: "service",
        caption: "Service code",
        order : 1,
      },
      {
        name: "Description",
        isPass: false,
        isEmail: false,
        type: "text",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        order : 2,
      },
      {
        name: "Purpose",
        isPass: false,
        isEmail: false,
        type: "text",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        order : 3,
      },
      {
        name: "Type",
        isPass: false,
        isEmail: false,
        type: "select",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        order : 4,
      },
      {
        name: "URL",
        isPass: false,
        isEmail: false,
        type: "url",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        order : 5,
      },
      {
        name: "Port",
        isPass: false,
        isEmail: false,
        type: "number",
        group: "service",
        placeholder : "Enter port number",
        order : 6,
      },
      {
        name: "Valid",
        isPass: false,
        isEmail: false,
        type: "bool",
        group: "service",
        order : 7,
      },
      {
        name: "Direction",
        isPass: false,
        isEmail: false,
        type: "select",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        tooltip : (<>
        <ul>
          <li>Recieve</li>
          <p>For this step use this service for recieving invoices</p>
          <li>Send</li>
          <p>For this step use this service for sending invoices</p>
          <li>Both</li>
          <p>For this step use this service for sending and receving invoices</p>
          <li>PushIEI</li>
          <p>Push IEI invoice object to API-REST endpoint (integration)</p>
          <li>PushREI</li>
          <p>Push REI invoice object to API-REST endpoint (integration)</p>
        </ul>
        </>),
        order : 8,
      },
      {
        name: "Definition",
        isPass: false,
        isEmail: false,
        type: "text",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        order : 9,
      },
      {
        name: "APIKey",
        isPass: false,
        isEmail: false,
        type: "text",
        group: "service",
        placeholder : "Enter API key",
        groupFields : ["ServiceEndPointCode"],
        caption : "API key",
        order : 10,
      },
      {
        name: "Certificate",
        isPass: false,
        isEmail: false,
        type: "file",
        group : "cert",
        groupFields : ["ServiceEndPointCode"],
        order : 11,
      },
      {
        name: "CertPass",
        isPass: true,
        isEmail: false,
        type: "password",
        group : "cert",
        placeholder : "Enter password",
        groupFields : ["ServiceEndPointCode"],
        caption : "Certificate password",
        order : 12,
      },
      {
        name: "CertDesc",
        isPass: false,
        isEmail: false,
        type: "text",
        group : "cert",
        groupFields : ["ServiceEndPointCode"],
        caption : "Certificate description",
        order : 13,
      },
      {
        name: "CertValidTo",
        isPass: false,
        isEmail: false,
        type: "date",
        group : "cert",
        caption: "Valid to",
        order : 14,
      },
      {
        name: "Mail",
        isPass: false,
        isEmail: true,
        type: "mail",
        group: "service",
        placeholder: "Enter email",
        order : 15,
      },
      {
        name: "ReplyTo",
        isPass: false,
        isEmail: false,
        type: "mail",
        group: "service",
        placeholder : "Enter email",
        caption: "Reply to",
        order : 16,
      },
      {
        name: "MailSenderName",
        isPass: false,
        isEmail: false,
        type: "text",
        group: "service",
        groupFields : ["ServiceEndPointCode"],
        placeholder : "Enter name",
        caption: "Sender name",
        order : 17,
      },
      {
        name: "LoginUsername",
        isPass: false,
        isEmail: false,
        type: "text",
        group : "login",
        groupFields : ["ServiceEndPointCode"],
        placeholder : "Enter login username",
        caption: "Login username",
        order : 18,
      },
      {
        name: "LoginPass",
        isPass: true,
        isEmail: false,
        type: "password",
        group : "login",
        groupFields : ["ServiceEndPointCode"],
        placeholder : "Enter login password",
        caption : "Login password",
        order : 19,
      },
      {
        name: "Notes",
        isPass: false,
        isEmail: false,
        type: "textarea",
        group: "notes",
        placeholder : "Enter any notes for your own later use. These notes are just for you.",
        order : 20,
      },
      {
        name: "RegDateToService",
        isPass: false,
        isEmail: false,
        type: "date",
        caption: "Registered date",
        order : 21,
      },
      {
        name: "UserCreate",
        isPass: false,
        isEmail: false,
        type: "text",
        caption : "Created by",
        order : 22,
      },
      {
        name: "DateTimeCreate",
        isPass: false,
        isEmail: false,
        type: "datetime",
        caption : "Created",
        order : 23,
      },
    ];

export const fieldsLayout = {
  groups : [
    {
      name: "service",
      caption: "Service info",
      order : 1
    },
    {
      name: "mail",
      caption: "Mail",
      order: 3
    },
    {
      name: "login",
      caption: "Login info",
      order: 4
    },
    {
      name: "cert",
      caption: "Certificate",
      order: 5
    },
    {
      name: "notes",
      caption: "Notes",
      order : 6
    }],
    fields : []
}